// shiftMasterSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { createShiftMaster, fetchAllShiftMasters, fetchShiftMasterById, updateShiftMaster, deleteShiftMaster } from './shiftMasterAction';
import { ShiftMasterState } from './shiftMasterType';

const initialState: ShiftMasterState = {
    shiftMasters: [],
    selectedShiftMaster: undefined,
    loadingStates: {
        create: false,
        fetchAll: false,
        fetchById: false,
        update: false,
        delete: false
    },
    errors: {
        create: undefined,
        fetchAll: undefined,
        fetchById: undefined,
        update: undefined,
        delete: undefined
    }
};

const shiftMasterSlice = createSlice({
    name: 'shiftMaster',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createShiftMaster.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createShiftMaster.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.shiftMasters.push(action.payload.data);
            })
            .addCase(createShiftMaster.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Fetch All
            .addCase(fetchAllShiftMasters.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllShiftMasters.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.shiftMasters = action.payload.data;
            })
            .addCase(fetchAllShiftMasters.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            })

            // Fetch By ID
            .addCase(fetchShiftMasterById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(fetchShiftMasterById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedShiftMaster = action.payload.data;
            })
            .addCase(fetchShiftMasterById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Update
            .addCase(updateShiftMaster.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(updateShiftMaster.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.shiftMasters.findIndex(
                    (shift) => shift.ShiftID === action.payload.ShiftID
                );
                if (index !== -1) {
                    state.shiftMasters[index] = action.payload;
                }
            })
            .addCase(updateShiftMaster.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete
            .addCase(deleteShiftMaster.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(deleteShiftMaster.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.shiftMasters = state.shiftMasters.filter(
                    (shift) => shift.ShiftID !== action.payload.ShiftID
                );
            })
            .addCase(deleteShiftMaster.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            });
    }
});

export default shiftMasterSlice.reducer;
